import referral from 'chimera/all/store/referral'

export default referral
